// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__kjXWb","right":"Footer_right__3KJ66","buttons":"Footer_buttons__21JG3"};